module.exports = __webpack_public_path__ + "img/tools_paytrend1.8c1ca50e.jpg";